import { Subject } from 'rxjs';

export class TamDashboardDrillDownConfig {
    show: boolean;
    style: any;
    id: string;
    value: string;
    category: string;
    type: string;
    name: string;
    readonly: boolean;
    tileConfig: any;
    focusedEntityIds: any;
    actionSubject$: Subject<any>;
    feedbackSubject$: Subject<any>;
    data?: any;
    constructor() {
        this.show = false;
    }
}
